import styled from 'styled-components';

export const GalleryWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 1440px;
  padding: 30px 0;
`;

export const Gallery = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
